import { render, staticRenderFns } from "./Variables.vue?vue&type=template&id=15ddec98&"
import script from "./Variables.vue?vue&type=script&lang=js&"
export * from "./Variables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports